export enum SearchParam {
  Keywords = 'keywords',
  OrderNumber = 'order_number',
  Statuses = 'statuses',
}
